export function toggle_loader() {
  document.body.classList.add('loading');
  setTimeout(function () {
    disable_loader();
  }, 15000);
}
export function disable_loader() {
  document.body.classList.remove('loading');
}